import { mapGetters, mapActions, mapMutations } from 'vuex'
import { expandCart, checkCartContent } from '../utils/orderProcessor'
import * as cartHelper from '../utils/cartHelper'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters([
      'products', 
      'ingredientGroups', 
      'addressSelected',
      'addresses', 
      'currentStore', 
      'stores', 
      'cart',
      'freePizzaRewardDeal',
      'fixedDealItems'
    ])
  },
  methods: {
    ...mapActions(['getOrderDetail', 'addToCart', 'setCurrentStore', 'getFixedDealItems']),
    ...mapMutations([
      'clearCart', 
      'setAddressSelected', 
      'setType', 
      'setPaymentMethod', 
      'setCart', 
      'setVoucher', 
      'setRequestedTime',
      'setCurrentOrder'
    ]),
    async setupStore (order) {
      if (!order.store) {
        return this.showAlert('Store not found', 'danger', 'Error')
      }
      const store = this.stores.find(store => store.id === order.store.id)
      if (!store) {
        return this.showAlert('Store is inactive', 'danger', 'Error')
      }
      if (!this.currentStore || (this.currentStore && this.currentStore.id !== store.id)) {
        await this.setCurrentStore({ store_id: store.id })
      }
    },
    setupCart (cart) {
      cart = expandCart(cart, this.products, this.ingredientGroups, true)
      for (let i = 0; i < cart.length; i++) {
        this.addToCart(cart[i])
      }
    },
    setupAddress (order) {
      if (this.type !== 'collection') {
        if (!order.address || order.address.deleted_at) {
          return false
        }
        if (!this.addressSelected || (this.addressSelected.id !== order.address.id)) {
          const addressSelected = this.addresses.find(address => address.id === order.address.id)
          if (!addressSelected) {
            // If order address does not exist anymore in customer address list, then redirect to logistics page
            return false
          }
          this.setAddressSelected(addressSelected)
        }
      }
      return true
    },
    setupTime (order) {
      if (this.timeOptions.length) {
        const selectedTime = this.timeOptions.find(time => time.value === order.requested_at)
        if (selectedTime) {
          this.selectedTime = selectedTime.value
        }
        this.selectedTime = this.timeOptions[0].value
        if (['web', 'app'].includes(this.$platform)) {
          this.setRequestedTime(this.selectedTime)
        }
        return true
      }
      return false
    },
    async setupOrder (order) {
      let cart = JSON.parse(order.order_data)

      // Old orders data must be verified and fixed sizes on deal items, by 15 Nov 2023
      if (moment(order.created_at).diff(moment('2023-11-15')) < 0) {
        await this.getFixedDealItems(order.id)
        cart = JSON.parse(JSON.stringify(this.fixedDealItems))
      }

      if (this.freePizzaRewardDeal) {
        // Removing free pizza reward deal from cart as we don't fill it up on reorder
        cart = cart.filter(item => item.id !== this.freePizzaRewardDeal.id)
      }
      cart = cartHelper.removeCartDiscount(cart)
      this.setCurrentOrder(null)
      if (['web', 'app'].includes(this.$platform)) {
        this.setVoucher(null)
        this.clearCart()
        await this.setupStore(order)
        const data = checkCartContent(cart, this.products, this.timezone)
        if (data.removedItems.length) {
          this.showAlert('We are no longer selling all the products from your previous order, please check the menu', 'danger', 'Error')
          if (!data.cart.length) {
            return
          }
        }
        this.setupCart(data.cart)
        this.setPaymentMethod(order.payment_type)
        this.setType(order.type)
        const addressOk = this.setupAddress(order)
        const timeOk = this.setupTime(order)
        if (!addressOk || !timeOk) {
          return this.redirectToLogistic()
        }
        this.redirectToCheckout()
      } else {
        if (!['delivery', 'collection', 'shop'].includes(this.type)) {
          return this.showAlert('Please select the type', 'danger')
        }
        if (this.type === 'delivery' && !this.addressSelected) {
          return this.showAlert('Please select the address', 'danger')
        }
        this.setCart([])
        const data = checkCartContent(cart, this.products, this.timezone)
        if (data.removedItems.length) {
          this.showAlert('We are no longer selling all the products from customer\'s previous order, please check the menu', 'danger', 'Error')
          if (!data.cart.length) {
            return
          }
        }
        this.setupCart(data.cart)
        this.$router.push({ path: '/ordering/menu/pizzas' })
      }
    }
  }
}
